import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import {
  PricingSection,
  MediaShowcase,
  IncludeSection,
  CallbackForm,
} from "../../../components/template";

import {
  getRetreatById,
} from "../../../services/retreatService";
const RetreatBooking = () => {
  const { retreatId } = useParams();

const [retreat, setRetreat] = useState(null);
const [loading, setLoading] = useState(true);

useEffect(() => {
  loadRetreat();
}, [retreatId]);

const loadRetreat = async () => {
  try {
    const res = await getRetreatById(retreatId);
    setRetreat(res.data);
  } catch (err) {
    console.error(err);
  } finally {
    setLoading(false);
  }
};
if (loading) {
  return (
    <div className="py-40 text-center">
      Loading...
    </div>
  );
}

if (!retreat) {
  return (
    <div className="py-40 text-center">
      Retreat Not Found
    </div>
  );
}
  const pricingData = {
    title: "Pricing Details",
    packages: retreat.packages || [],
    offers: [],
  };

  const validCoupons = {};

  const accomodateItems =
    retreat.accommodationImages?.map((img) => ({
      type: "image",
      src: img,
    })) || [];

  const whatsInclHeading =
    "What's Included?";

  const whatsInclMainImage =
    retreat.accommodationImages?.[0] || "";

  const whatsInclItems =
    retreat.includedItems?.map((item) => ({
      icon: "✨",
      heading: item,
      points: [],
    })) || [];

  return (
    <>
      {/* Hero */}
<section className="relative overflow-hidden bg-[#1D2D2B] py-28">
  {/* Decorative Background */}
  <div className="absolute inset-0">
    <div className="absolute -top-32 -left-20 w-[420px] h-[420px] rounded-full bg-[#F28C28]/20 blur-[140px]" />
    <div className="absolute bottom-0 right-0 w-[500px] h-[500px] rounded-full bg-[#F5D2B4]/10 blur-[180px]" />
    <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] rounded-full border border-white/5" />
  </div>

  <div className="relative max-w-7xl mx-auto px-6">

    <div className="grid lg:grid-cols-2 gap-20 items-center">

      {/* LEFT CONTENT */}
      <div>

        <span className="inline-flex items-center gap-2 bg-white/10 border border-white/10 backdrop-blur-xl rounded-full px-5 py-2 text-sm tracking-[0.25em] uppercase text-[#F7D4A4]">
          ✨ Upcoming Retreat
        </span>

        <h1 className="mt-8 text-[clamp(48px,7vw,82px)] leading-[0.95] tracking-[-0.05em] font-light text-white">
          {retreat.retreatTitle}
        </h1>

        <p className="mt-8 text-lg leading-9 text-white/70 max-w-xl">
          Disconnect from the noise and reconnect with yourself through
          mindfulness, nature, movement and transformational experiences
          crafted to restore your body, mind and soul.
        </p>

        {/* Info Cards */}
        <div className="grid sm:grid-cols-3 gap-5 mt-12">

          <div className="rounded-3xl bg-white/8 backdrop-blur-2xl border border-white/10 p-6">

            <div className="text-3xl">📍</div>

            <p className="mt-5 text-xs uppercase tracking-[0.25em] text-white/40">
              Location
            </p>

            <h3 className="mt-2 text-lg text-white font-medium">
              {retreat.location || "Coming Soon"}
            </h3>

          </div>

          <div className="rounded-3xl bg-white/8 backdrop-blur-2xl border border-white/10 p-6">

            <div className="text-3xl">🗓️</div>

            <p className="mt-5 text-xs uppercase tracking-[0.25em] text-white/40">
              Dates
            </p>

            <h3 className="mt-2 text-lg text-white font-medium">
              {retreat.startDate} — {retreat.endDate}
            </h3>

          </div>

          <div className="rounded-3xl bg-gradient-to-br from-[#F28C28] via-[#F5A146] to-[#F8C36D] p-6 shadow-2xl">

            <div className="text-3xl">💎</div>

            <p className="mt-5 text-xs uppercase tracking-[0.25em] text-white/80">
              Starting From
            </p>

            <h3 className="mt-2 text-3xl font-semibold text-white">
              ₹{retreat.startingPrice || "--"}
            </h3>

          </div>

        </div>

      </div>

      {/* RIGHT IMAGE */}
      <div className="relative">

        <div className="absolute -top-10 -right-10 w-44 h-44 rounded-full bg-[#F28C28]/20 blur-3xl" />

        <div className="relative overflow-hidden rounded-[42px] border border-white/10 shadow-[0_40px_120px_rgba(0,0,0,.35)]">

          <img
            src={
              retreat.cardImage ||
              retreat.accommodationImages?.[0]
            }
            alt={retreat.retreatTitle}
            className="w-full h-[620px] object-cover"
          />

          <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-transparent to-transparent" />

        </div>

      </div>

    </div>

  </div>
</section>
      {/* Pricing */}
      <PricingSection
        data={pricingData}
        validCoupons={validCoupons}
        dueDate={retreat.startDate}
        program={retreat.retreatTitle}
      />

      {/* Accommodation */}
      <MediaShowcase
        title="Accommodation"
        mediaItems={accomodateItems}
      />

      {/* Included */}
      <div className="bg-white p-6">
        <IncludeSection
          mainImage={whatsInclMainImage}
          heading={whatsInclHeading}
          items={whatsInclItems}
        />
      </div>

      <CallbackForm />
    </>
  );
};

export default RetreatBooking;